/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from '~/core';
setup();

import '~/global/_body';
import '~/global/_header';
import '~/global/_footer';

import '~/components/_accordion';
import '~/components/_byLawsAndRulesTable';
import '~/components/_filterMultiSelect';
import '~/components/_forms';
import '~/components/_marketData';
import '~/components/_swiper';
import '~/components/_subCenter';
import '~/components/_timeline';
import '~/components/_topicList';
import '~/components/_transformations';
import '~/components/_videoPlayer';
import '~/components/the-occ-updates/_showMoreList';
